// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** 延期券签字 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /sign/delay_coupon */
export async function signDelayCouponUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.signDelayCouponUsingPOSTParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultESignDelayCouponStartResp>(
    "/sign/delay_coupon",
    {
      method: "POST",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 延期券生成签字pdf # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /sign/delay_coupon/generateSignPdf */
export async function signDelayCouponGenerateSignPdfUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.signDelayCouponGenerateSignPdfUsingPOSTParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultstring>("/sign/delay_coupon/generateSignPdf", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取签字url # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /sign/delay_coupon/signUrl */
export async function signDelayCouponSignUrlUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.signDelayCouponSignUrlUsingPOSTParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultstring>("/sign/delay_coupon/signUrl", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
